import { createContext, useContext } from 'react';

export interface PaginationContextState {
  pageSize: number;
  setPageSize: (value: number) => void;
  currentPage: number;
  setCurrentPage: (value: number) => void;
}

export const defaultState: PaginationContextState = {
  pageSize: 0,
  setPageSize: () => undefined,
  currentPage: 0,
  setCurrentPage: () => undefined,
};

export const PaginationContext = createContext<PaginationContextState>(defaultState);

export const usePaginationContext = () => useContext(PaginationContext);
